import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Modal, Tabs, List, Input, Button, Row, Col, Upload, message } from 'antd';
import {
  pixabaySearch, getMedias, addFromPixabay, usePixabay, changeUploadStatus,
} from '../../actions/gallery';
import { LoadingSpinner } from '../../presentation/LoadingSpinner';
import app_params from '../../../../config/params';
import {
  CloudUploadOutlined,
  PlusOutlined,
  StopOutlined,
  DownloadOutlined,
  UploadOutlined,
  SearchOutlined,
  LoadingOutlined,
  PictureOutlined,
} from '@ant-design/icons';

const { TabPane } = Tabs;
const { Search } = Input;
const { Dragger } = Upload;

const mediaUploadUrl = `${app_params.GAE_ENDPOINT.BASE_URL}api/media/upload`;

export class GallerySelectModal extends React.Component {
  state = {
    showPixabayModal: false,
  };
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    gallery: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    token: PropTypes.string.isRequired,
    sender: PropTypes.shape({
      blockUrlsafe: PropTypes.string,
      address: PropTypes.array,
      selectedProp: PropTypes.string,
      renderSize: PropTypes.string,
    }),
    onBlockUpdate: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.loadGallery();
  }

  componentDidUpdate(prevProps) {

    const { pixabayMedia: prevPixabayMedia } = prevProps.gallery;
    const { pixabayMedia } = this.props.gallery;
    if (prevPixabayMedia === null && pixabayMedia !== null && this.props.sender !== null) {
      this.props.dispatch(usePixabay());
      const { blockUrlsafe, address, selectedProp } = this.props.sender;
      this.props.onBlockUpdate(blockUrlsafe, address, { [selectedProp]: pixabayMedia.urlsafe });
      this.props.onClose();
      this.setState({ showPixabayModal: false });
      message.success({ content: 'Pixabay image imported successfully', key: 'KEY_PIXABAY_SELECT'});
    }

  }

  onDraggerChange = (info) => {
    this.props.dispatch(changeUploadStatus(info));
    const { status } = info.file;
    if (status === 'done') {
      message.success(`${info.file.name} file uploaded successfully.`);
    }
    else if (status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  onPixabaySearch = (value) => {
    this.props.dispatch(pixabaySearch(value));
  };

  galleryItemSelected = (item) => {
    const { blockUrlsafe, address, selectedProp, renderSize } = this.props.sender;
    const {urlsafe: mediaUrlsafe} = item;
    this.props.onBlockUpdate(blockUrlsafe, address, { [selectedProp]: mediaUrlsafe });
    this.props.onClose();
  };

  incompatGalleryItemSelected = () => {
    message.warning({ content: 'Image too small. Choose a bigger image.', key: 'KEY_INCOMPAT_WARNING'});
  };

  renderGalleryItem = (item) => {

    let renderSize = null;
    if (this.props.sender !== null
      && 'renderSize' in this.props.sender
      && this.props.sender.renderSize !== null ) {
      renderSize = this.props.sender.renderSize;
    }

    let enabled = false;
    if ('resolutions' in item) {
      if (renderSize === 'lg') {
        if ('large' in item.resolutions && item.resolutions.large !== null && 'path' in item.resolutions.large) {
          enabled = true;
        }
      }
      if (renderSize === 'md') {
        if ('medium' in item.resolutions && item.resolutions.medium !== null && 'path' in item.resolutions.medium) {
          enabled = true;
        }
      }
      if (renderSize === 'sm') {
        if ('small' in item.resolutions && item.resolutions.small !== null && 'path' in item.resolutions.small) {
          enabled = true;
        }
      }
    }

    let thumbSrc = null;
    if ('resolutions' in item &&
      'thumb' in item.resolutions &&
      item.resolutions.thumb !== null &&
      'path' in item.resolutions.thumb &&
      item.resolutions.thumb.path !== null
    ) {
      thumbSrc = `${app_params.GAE_ENDPOINT.MEDIA_URL}${item.resolutions.thumb.path}`;
    }

    const enabledBtn = (
      <Button type="link" icon={<PlusOutlined />} onClick={() => this.galleryItemSelected(item)}>Insert image</Button>
    );
    const disabledBtn = (
      <Button type="link" icon={<StopOutlined />} onClick={this.incompatGalleryItemSelected}>Incompatible</Button>
    );
    const btn = enabled ? enabledBtn : disabledBtn;
    return (
      <List.Item key={item.id}>
        <div
          className={cx(
            "editor__gallery__item rounded overflow-hidden shadow-sm mb-4 text-center bg-white",
            { disabled: !enabled },
          )}
        >
          <img alt={item.name} src={thumbSrc} />
          { btn }
        </div>
      </List.Item>
    );
  }

  galleryTabContent = (gallery) => (
    <List
      className="gallery__tab__content"
      itemLayout="vertical"
      dataSource={gallery.medias}
      grid={{ gutter: 18, xs: 2, sm: 3, md: 4, lg: 4, xl: 4, xxl: 4 }}
      pagination={{ pageSize: 48 }}
      renderItem={this.renderGalleryItem}
    />
  );

  uploadTabContent = (gallery, token) => (
    <div>
      <Dragger
        name="file"
        multiple={true}
        listType="picture"
        onChange={this.onDraggerChange}
        action={mediaUploadUrl}
        headers={{ Authorization: token }}
        showUploadList={true}
      >
        <CloudUploadOutlined className="text-muted" style={{ fontSize: 48 }} />
        <h5 className="my-3">Click or drag photos here to upload</h5>
        <div className="small text-muted">Uploaded files are subject to copyright terms</div>
      </Dragger>
    </div>
  );

  // comments // : // 78
  // downloads // : // 188788
  // favorites // : // 605
  // fullHDURL // : // "https://pixabay.com/get/ea35b90f2ef0053ecd0b400de6484194e46ae3d01ab4184896f9c278_1920.jpg"
  // id // : // 3080644
  // id_hash // : // "3080644"
  // imageHeight // : // 3336
  // imageSize // : // 2895347
  // imageURL // : // "https://pixabay.com/get/ea35b90f2ef0053ecd0b400de6484194e46ae3d01ab4184896f9c278.jpg"
  // imageWidth // : // 5340
  // largeImageURL // : // "https://pixabay.com/get/ea35b90f2ef0053ecd0b400de6484194e46ae3d01ab4184896f9c278_1280.jpg"
  // likes // : // 772
  // pageURL // : // "https://pixabay.com/en/fashion-woman-portrait-model-girl-3080644/"
  // previewHeight // : // 93
  // previewURL // : // "https://cdn.pixabay.com/photo/2018/01/13/19/39/fashion-3080644_150.jpg"
  // previewWidth // : // 150
  // tags // : // "fashion, woman, portrait"
  // type // : // "photo"
  // user // : // "himanshugunarathna"
  // userImageURL // : // "https://cdn.pixabay.com/user/2017/12/01/06-39-48-119_250x250.jpg"
  // user_id // : // 3935302
  // views // : // 325590
  // webformatHeight // : // 399
  // webformatURL // : // "https://pixabay.com/get/ea35b90f2ef0053ecd0b400de6484194e46ae3d01ab4184896f9c278_640.jpg"
  // webformatWidth // : // 640

  formatBytes = (a, b) => {
    if (a === 0) {
      return '0 Bytes';
    }
    const c = 1024;
    const d = b || 2;
    const e = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const f = Math.floor(Math.log(a) / Math.log(c));
    return `${parseFloat((a / (c ** f)).toFixed(d))} ${e[f]}`;
  }

  pixabayItemSelected = (image) => {
    this.props.dispatch(addFromPixabay(image));
    this.setState({ showPixabayModal: true });
    // message.loading({ content: 'Optimizing Pixabay image', key: 'KEY_PIXABAY_SELECT'});
  };

  renderPixabayItem = (item) => (
    <List.Item key={item.id_hash}>
      <div className="editor__pixabay__item rounded shadow-sm overflow-hidden text-center mb-4 bg-white">
        <img alt={item.tags} src={item.previewURL} />
        <Button type="link" icon={<DownloadOutlined />} onClick={() => this.pixabayItemSelected(item)}>Add image</Button>
      </div>
    </List.Item>
  );

  pixabayTabContent = ({ searchquery, searchstatus, pixabay }) => {
    const searchInputResp = {
      xs: 24,
      sm: { span: 18, offset: 3 },
      md: { span: 16, offset: 4 },
      lg: { span: 12, offset: 6 },
    };
    const isSearching = searchstatus === 'searching';

    const searchResults = isSearching ? (
      <LoadingSpinner />
    ) : (
      <List
        itemLayout="vertical"
        className="pixabay__tab__content"
        dataSource={pixabay.hits}
        grid={{ gutter: 16, xs: 2, sm: 3, md: 4, lg: 4, xl: 4, xxl: 4 }}
        pagination={{ pageSize: 48 }}
        renderItem={this.renderPixabayItem}
      />
    );

    return (
      <React.Fragment>
        <Row gutter={18}>
          <Col {...searchInputResp}>
            <Search
              placeholder="Keyword to search"
              onSearch={this.onPixabaySearch}
              enterButton={isSearching ? <LoadingOutlined /> : <SearchOutlined />}
              size="large"
              className="mt-3 mb-5"
              defaultValue={searchquery}
            />
          </Col>
        </Row>
        <div>
          { searchResults }
        </div>
      </React.Fragment>
    );
  }

  loadGallery = () => {
    const { gallery } = this.props;
    const { status } = gallery;
    if (status === 'init') {
      this.props.dispatch(getMedias());
    }
  };

  tabChanged = (key) => {
    if (key === 'gallery') {
      this.loadGallery();
    }
  };

  render() {
    const { gallery, token } = this.props;

    const tabs = (
      <Tabs
        defaultActiveKey="gallery"
        tabBarExtraContent={<div style={{width: 40, height:40}}></div>}
        onChange={this.tabChanged}
      >
        <TabPane tab={<span><PictureOutlined />My Gallery</span>} key="gallery">{this.galleryTabContent(gallery)}</TabPane>
        <TabPane tab={<span><UploadOutlined />Upload</span>} key="upload">{this.uploadTabContent(gallery, token)}</TabPane>
        <TabPane tab={<span><SearchOutlined />Pixabay</span>} key="pixabay">{this.pixabayTabContent(gallery)}</TabPane>
      </Tabs>
    );

    return (
      <React.Fragment>
        <Modal
          title={null} visible={this.props.visible}
          closable={true} maskClosable={true} footer={null} width={768}
          wrapClassName="editor__gallery__modal__container"
          destroyOnClose={true}
          onCancel={this.props.onClose}
        >
          {tabs}
        </Modal>
        <Modal
          title={null} visible={this.state.showPixabayModal}
          closable={false} maskClosable={false} footer={null}
          zIndex={1500}
          destroyOnClose={true}
        >
          <h3>Optimizing Image</h3>
          <div className="text-secondary">This might take a while</div>
        </Modal>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/editor/GallerySelectModal.jsx